import { Routes, Route, Navigate } from 'react-router-dom'
import { ProtectedRoute, PublicRoute, RequireGroups } from '@/router/ProtectedRoute'
import { AppLayout } from '@/shared/components/layouts'
import { LegacyView } from '@/shared/components'
import { LoginPage, ForgotPasswordPage, ResetPasswordPage } from '@/auth'
import { HomePage } from '@/modules/home'
import { DashboardPage } from '@/modules/dashboard'
import { CampaniasSeguimiento, CampaniasAnalytics, CampaniaDetalle, CampaniaCreate, CampaniaEdit, CampaniaDuplicar, ReporteDetalle, ReporteWhatsAppDetalle, ConfiguracionCampanias } from '@/modules/multichannel'
import { CalendarioPage } from '@/modules/cronograma'
import { AccountPage } from '@/modules/account'
import { UsersPage, GroupsPage, LaboratoriosPage, AreasPage } from '@/modules/users'
import {
  ContactosPage as BdUnificadaContactosPage,
  FuentesPage as BdUnificadaFuentesPage,
  ColaPage as BdUnificadaColaPage,
  ConfiguracionPage as BdUnificadaConfiguracionPage,
} from '@/modules/bd-unificada'
import { ReportesPage, ConfiguracionPage, AsistenciasDashboardPage, AdiumRegistrosPage, AdiumEncuestaPage } from '@/modules/registros'
import { ReporteDetallePage } from '@/features/registros'
import { DashboardPersonalizadoPage } from '@/modules/registros-dashboard'
import { RegistroPage, SeguimientoPage } from '@/modules/medifarma'
import {
  ConfiguracionWhatsApp,
  PlantillasWhatsApp,
  EnvioMasivoWhatsApp,
  HistorialWhatsApp,
  AnalyticsWhatsApp
} from '@/modules/whatsapp'
import {
  DashboardLinkTracker,
  ListaURLs,
  CrearURL,
  AnalyticsURLPage
} from '@/modules/link-tracker'
import { ConfiguracionClientesPage, ReportesClientePage } from '@/modules/clientes'
import { ConfiguracionProgrammaticPage, ReportesProgrammaticPage } from '@/modules/programmatic'
import { ConfiguracionAnalyticsPage, ReportesAnalyticsPage } from '@/modules/analytics'
import {
  ReportesFidelizacionPage,
  ConfiguracionFidelizacionPage,
  ReporteFidelizacionDetallePage,
  RegistrosFidelizacionPage,
  RepresentantesFidelizacionPage,
  VentasFidelizacionPage,
  CanjesFidelizacionPage,
  ParticipantesFidelizacionPage,
  TabFidelizacionGuard,
  GRUPOS_FIDELIZACION_VIEW,
} from '@/modules/reportes-fidelizacion'
import { ConfiguracionSueroterapiaPage, ReporteSueroterapiaPage } from '@/modules/sueroterapia'
import { ConfiguracionAnalyticsDifarePage, ReporteAnalyticsDifarePage } from '@/modules/analytics-difare'
import { ConfiguracionAnalyticsOdfPage, ReporteAnalyticsOdfPage } from '@/modules/analytics-odf'
import { VisualizacionesPage, VisualizacionDetailPage } from '@/modules/visualizaciones'
import { ConfiguracionWebinarsPage, ReportesWebinarsPage } from '@/modules/webinars'
import { WebinarsGrupoFarmaPage } from '@/modules/webinars-analytics'
import { PasswordsPage } from '@/modules/passwords'
import { NotificacionesPage } from '@/modules/notificaciones'
import { PricingAdminPage, PricingPublicPage } from '@/modules/pricing'
import {
  EncuestasListPage,
  EncuestaCreatePage,
  EncuestaEditPage,
  EncuestaPreviewPage,
  ReportesListPage as EncuestasReportesListPage,
  ReporteDatosPage as EncuestasReporteDatosPage,
  ReporteEstadisticasPage as EncuestasReporteEstadisticasPage,
  EncuestaPublicaPage as EncuestasPublicaPage,
  EncuestasGraciasPage,
  EncuestasResultadosPage,
  EncuestasYaRespondidaPage,
  EncuestasNoDisponiblePage,
} from '@/modules/encuestas'
import {
  DashboardBdClientesPage,
  ClientesListPage,
  ClienteDetailPage,
  ClienteFormPage,
  BulkUploadPage,
  ConfiguracionBdClientesPage,
  LaboratoriosDashboardPage,
  LaboratoriosListPage,
  LaboratorioDetailPage,
  LaboratorioFormPage,
  LaboratoriosConfigPage,
} from '@/modules/bd-clientes'
import {
  SorteosListPage,
  SorteoFormPage,
  SorteoDetailPage,
} from '@/modules/sorteos'
import {
  CampaniasListPage,
  CampaniaDetallePage,
  ReporteDatosPage,
  FormBuilderPage,
  EncuestasAdminPage,
  EncuestaFormBuilderPage,
  EncuestaAnaliticasPage,
  SolicitudPublicaPage,
  EncuestaPublicaPage,
  GraciasPage,
  NoDisponiblePage,
  YaSolicitadaPage,
} from '@/modules/muestras-medicas'
import {
  LibrosListPage as QRLibrosListPage,
  LibroFormPage as QRLibroFormPage,
  LibroDetailPage as QRLibroDetailPage,
  ValidarCodigoPage as QRValidarCodigoPage,
  FormularioPage as QRFormularioPage,
  DescargaPage as QRDescargaPage,
  CodigoUsadoPage as QRCodigoUsadoPage,
  SolicitudPage as QRSolicitudPage,
} from '@/modules/libro-qr'
import { CodigosQRPage } from '@/modules/codigos-qr'
import { SeguimientoReportesPage, SeguimientoDetallePage } from '@/modules/seguimiento-reportes'
import { EstadisticasPage } from '@/modules/estadisticas'
import { ConsumoIAPage } from '@/modules/consumo-ia'
import { ConsumoMetaPage, ConsumoMetaLabPage } from '@/modules/consumo-meta'
import { FlowListPage, FlowBuilderPage } from '@/modules/email-flows'
import {
  DashboardCEMCPage,
  ConfiguracionCEMCPage,
  GestionFuentesPage,
  ReporteCEMCPage,
} from '@/modules/cemc-educacion'
import {
  BagoBd0326Page,
  NaosSegmentoPage,
  GlenmarkBd0326Page,
  SavalBd0826Page,
  NeurointegraBd1026Page,
  BagoRespiratoriaPage,
  AbbottSegmentoPage,
  AbbottBdSegmentada3003Page,
  EurofarmaSegmento1604Page,
  MegalabsPanel0426Page,
  MegalabsCardioMetabol0426Page,
  MegalabsFarmacias2307Page,
  EleaPanel0426Page,
  Elea0610Page,
  AllegraBilaxtenPage,
  OpellaEnero2026Page,
  OpellaDashboardPage,
  Allegra0226Page,
  OpellaNoValginaPage,
  FerrerMedicosPeru0218Page,
  OdfFarmacias0126Page,
  OdfSegmento0726Page,
  EleaSegmento0309Page,
  Farmacias0503Page,
  UnipharmBd0326Page,
  OpellaProbioticosCrucePage,
  GastroOpellaPage,
  MuestrasEfectividadPage,
  BiotoscanaPage,
  NerasildaTadanerfilPage,
  OpellaPanamaPage,
  OpellaDermatologosPage,
  ExeltisPeruPage,
  Dkt0626Page,
  Panama0226Page,
  BdOdt141025Page,
  FerrerMedicosPeruPage,
  BaseMedicosTonal2026Page,
  MedicosEspecialidadesPage,
  FerrerProgrammatic2025Page,
  FerrerProgrammatic2026Page,
  FerrerProgrammaticVsPage,
  FerrerCampanas2025Page,
  AbbottPropuestaMenopausiaPage,
  NestleNutrirNoviembrePage,
  MediafarmaPeruProyeccionPage,
  MedifarmaPeru2027Page,
  TonalColombiaBdPage,
  TonalFidelizacionProyeccionPage,
  MediafarmaPeruExcluidasPage,
  MediafarmaPeruSepExcluidasPage,
  PsiquiatrasEcuPage,
  CardiologosDifarePage,
  Difare0726Page,
  GskBd0726Page,
  MegalabsBd0728Page,
  HumanovaPeruPage,
  OpellaMedicosEcuadorPage,
  PanelEnriquecidoPage,
  BaseMedicosUnificadaPage,
  DashAdminPage,
  DependientesGlobalPage,
  DicasenPage,
} from '@/modules/dash'

// Legacy views for Django pages (deprecated - siendo migradas a React)
// function CronogramaPage() {
//   return <LegacyView path="/cronograma/seguimiento/" title="Cronograma" />
// }

function ContenidoPage() {
  return <LegacyView path="/contenido/" title="Contenido" />
}

// WhatsApp migrated to React - see imports above
// function WhatsAppPage() {
//   return <LegacyView path="/whatsapp/envio-masivo/" title="WhatsApp" />
// }

// Registros migrated to React - see imports above

// CronogramaConfiguracionPage migrado a React - ver ConfiguracionCampanias

function App() {
  return (
    <Routes>
      {/* Public route - redirects to home if already authenticated */}
      <Route
        path="/login"
        element={
          <PublicRoute>
            <LoginPage />
          </PublicRoute>
        }
      />

      {/* Recuperación de contraseña - Público (sin autenticación) */}
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />

      {/* Public Medifarma registration route - no authentication required */}
      <Route path="/medifarma/conecta/solicitar-registro" element={<RegistroPage />} />

      {/* Pricing - Calculadora pública (sin autenticación) */}
      <Route path="/pricing" element={<PricingPublicPage />} />

      {/* Encuestas - Público (sin autenticación) */}
      <Route path="/encuestas/responder/:uuid" element={<EncuestasPublicaPage />} />
      <Route path="/encuestas/gracias/:uuid" element={<EncuestasGraciasPage />} />
      <Route path="/encuestas/resultados/:uuid/:sesionUuid" element={<EncuestasResultadosPage />} />
      <Route path="/encuestas/ya-respondida" element={<EncuestasYaRespondidaPage />} />
      <Route path="/encuestas/no-disponible" element={<EncuestasNoDisponiblePage />} />

      {/* Muestras Médicas - Público (sin autenticación) */}
      <Route path="/muestras-medicas/solicitar/:uuid" element={<SolicitudPublicaPage />} />
      <Route path="/muestras-medicas/gracias/:uuid" element={<GraciasPage />} />
      <Route path="/muestras-medicas/encuesta/:uuid" element={<EncuestaPublicaPage />} />
      <Route path="/muestras-medicas/encuesta/gracias/:uuid" element={<GraciasPage />} />
      <Route path="/muestras-medicas/no-disponible" element={<NoDisponiblePage />} />
      <Route path="/muestras-medicas/ya-solicitada" element={<YaSolicitadaPage />} />

      {/* Dash Reports - Público (sin autenticación) */}
      {/* Type A - Segmentación simple */}
      <Route path="/dash/naos/segmento-0323" element={<NaosSegmentoPage />} />
      <Route path="/dash/panel-enriquecido" element={<PanelEnriquecidoPage />} />
      <Route path="/dash/bago/bd-0326" element={<BagoBd0326Page />} />
      <Route path="/dash/glenmark/bd-0326" element={<GlenmarkBd0326Page />} />
      <Route path="/dash/saval/bd-0826" element={<SavalBd0826Page />} />
      <Route path="/dash/neurointegra/bd-1026" element={<NeurointegraBd1026Page />} />
      <Route path="/dash/bago/bd/respiratoria1225" element={<BagoRespiratoriaPage />} />
      <Route path="/dash/abbott/bd/segmento1225" element={<AbbottSegmentoPage />} />
      <Route path="/dash/abbott/bd-segmentada-3003" element={<AbbottBdSegmentada3003Page />} />
      <Route path="/dash/abbott/propuesta-menopausia" element={<AbbottPropuestaMenopausiaPage />} />
      <Route path="/dash/nestle/nutrir/noviembre" element={<NestleNutrirNoviembrePage />} />
      <Route path="/dash/eurofarma/segmento-1604" element={<EurofarmaSegmento1604Page />} />
      <Route path="/dash/megalabs/panel-0426" element={<MegalabsPanel0426Page />} />
      <Route path="/dash/megalabs/cardio-metabolismo-0426" element={<MegalabsCardioMetabol0426Page />} />
      <Route path="/dash/megalabs/farmacias-2307" element={<MegalabsFarmacias2307Page />} />
      <Route path="/dash/elea/panel-0426" element={<EleaPanel0426Page />} />
      <Route path="/dash/elea/0610" element={<Elea0610Page />} />
      <Route path="/dash/psiquiatras/ecuador" element={<PsiquiatrasEcuPage />} />
      <Route path="/dash/difare/cardiologos" element={<CardiologosDifarePage />} />
      <Route path="/dash/difare/bd-0726" element={<Difare0726Page />} />
      <Route path="/dash/gsk/bd-0726" element={<GskBd0726Page />} />
      <Route path="/dash/megalabs/bd-0728" element={<MegalabsBd0728Page />} />
      <Route path="/dash/humanova/peru" element={<HumanovaPeruPage />} />
      <Route path="/dash/dependientes/global" element={<DependientesGlobalPage />} />
      {/* Type B - Multi-nivel */}
      <Route path="/dash/opella/allegra-bilaxten-2026" element={<AllegraBilaxtenPage />} />
      <Route path="/dash/opella/enero-2026" element={<OpellaEnero2026Page />} />
      <Route path="/dash/opella/dashboard" element={<OpellaDashboardPage />} />
      <Route path="/dash/opella/medicos-ecuador" element={<OpellaMedicosEcuadorPage />} />
      <Route path="/dash/opella/allegra-0226" element={<Allegra0226Page />} />
      <Route path="/dash/opella/novalgina-ecuador" element={<OpellaNoValginaPage />} />
      <Route path="/dash/ferrer/medicos-peru-0218" element={<FerrerMedicosPeru0218Page />} />
      <Route path="/dash/ferrer/programmatic/2025" element={<FerrerProgrammatic2025Page />} />
      <Route path="/dash/ferrer/programmatic/2026" element={<FerrerProgrammatic2026Page />} />
      <Route path="/dash/ferrer/programmatic/vs" element={<FerrerProgrammaticVsPage />} />
      <Route path="/dash/ferrer/campanas/2026" element={<FerrerCampanas2025Page />} />
      <Route path="/dash/medifarma-peru/proyeccion" element={<MediafarmaPeruProyeccionPage />} />
      <Route path="/dash/medifarma-peru/2027" element={<MedifarmaPeru2027Page />} />
      <Route path="/dash/bd/tonal/colombia" element={<TonalColombiaBdPage />} />
      <Route path="/dash/tonal/fidelizacion/proyeccion" element={<TonalFidelizacionProyeccionPage />} />
      <Route path="/dash/medifarma-peru/facturas-excluidas" element={<MediafarmaPeruExcluidasPage />} />
      <Route path="/dash/medifarma-peru/septiembre/facturas-excluidas" element={<MediafarmaPeruSepExcluidasPage />} />
      {/* Type C - Multi-filtro */}
      <Route path="/dash/odf/farmacias-0126" element={<OdfFarmacias0126Page />} />
      <Route path="/dash/odf/segmento-0726" element={<OdfSegmento0726Page />} />
      <Route path="/dash/elea/segmento-0309" element={<EleaSegmento0309Page />} />
      <Route path="/dash/tonal/farmacias-0503" element={<Farmacias0503Page />} />
      <Route path="/dash/unipharma/bd-0326" element={<UnipharmBd0326Page />} />
      <Route path="/dash/opella/probioticos-cruce-0126" element={<OpellaProbioticosCrucePage />} />
      {/* Type D - Match/Cruce */}
      <Route path="/dash/gastro-opella-reporte" element={<GastroOpellaPage />} />
      <Route path="/dash/opella/muestras-efectividad" element={<MuestrasEfectividadPage />} />
      <Route path="/dash/biotoscana/a4b2-c8d9-e1f7" element={<BiotoscanaPage />} />
      <Route path="/dash/odt/e3cf-a664-4da1" element={<NerasildaTadanerfilPage />} />
      {/* Type E - Listas especialidades */}
      <Route path="/dash/opella/panama" element={<OpellaPanamaPage />} />
      <Route path="/dash/opella/dermatologos" element={<OpellaDermatologosPage />} />
      <Route path="/dash/exeltis/ginecologos" element={<ExeltisPeruPage />} />
      <Route path="/dash/dkt/ginecologia-0626" element={<Dkt0626Page />} />
      <Route path="/dash/panama/0226" element={<Panama0226Page />} />
      <Route path="/dash/odt/f7b2-9e45-3c18" element={<BdOdt141025Page />} />
      <Route path="/dash/ferrer/medicos-peru-0126" element={<FerrerMedicosPeruPage />} />
      {/* Type F - Análisis médico */}
      <Route path="/dash/base-medicos-tonal-0126" element={<BaseMedicosTonal2026Page />} />
      <Route path="/dash/bd/colombia/validacion" element={<BaseMedicosUnificadaPage />} />
      <Route path="/dash/medicos/especialidades" element={<MedicosEspecialidadesPage />} />

      {/* Adium Dicasen - PDF público (sin autenticación) */}
      <Route path="/adium/dicasen" element={<DicasenPage />} />

      {/* QR Código - Público (sin autenticación) */}
      <Route path="/qr/:uuid" element={<QRValidarCodigoPage />} />
      <Route path="/qr/:uuid/formulario" element={<QRFormularioPage />} />
      <Route path="/qr/:uuid/usado" element={<QRCodigoUsadoPage />} />
      <Route path="/qr/:uuid/solicitar" element={<QRSolicitudPage />} />
      <Route path="/qr/descarga/:token" element={<QRDescargaPage />} />

      {/* Sorteo Detail - standalone (sin AppLayout) */}
      <Route
        path="/sorteos/:id/vista"
        element={
          <ProtectedRoute>
            <SorteoDetailPage />
          </ProtectedRoute>
        }
      />

      {/* Protected routes with AppLayout */}
      <Route
        element={
          <ProtectedRoute>
            <AppLayout />
          </ProtectedRoute>
        }
      >
        {/* Home */}
        <Route index element={<HomePage />} />

        {/* Dashboard */}
        <Route path="dashboard" element={<DashboardPage />} />

        {/* Doppler Beta - Email Flows (solo admin) */}
        <Route
          path="doppler-flows"
          element={
            <RequireGroups groups={['admin']}>
              <FlowListPage />
            </RequireGroups>
          }
        />
        <Route
          path="doppler-flows/:id"
          element={
            <RequireGroups groups={['admin']}>
              <FlowBuilderPage />
            </RequireGroups>
          }
        />

        {/* Account */}
        <Route path="cuenta" element={<AccountPage />} />

        {/* Multichannel - mailing, mailing_admin o admin */}
        <Route path="multichannel/seguimiento" element={<RequireGroups groups={['mailing', 'mailing_admin', 'admin']}><CampaniasSeguimiento /></RequireGroups>} />
        <Route path="multichannel/analytics" element={<RequireGroups groups={['mailing', 'mailing_admin', 'admin']}><CampaniasAnalytics /></RequireGroups>} />
        <Route path="multichannel/campania/nueva" element={<RequireGroups groups={['mailing_admin', 'admin']}><CampaniaCreate /></RequireGroups>} />
        <Route path="multichannel/campania/:id/duplicar" element={<RequireGroups groups={['mailing_admin', 'admin']}><CampaniaDuplicar /></RequireGroups>} />
        <Route path="multichannel/campania/:id/editar" element={<RequireGroups groups={['mailing_admin', 'admin']}><CampaniaEdit /></RequireGroups>} />
        <Route path="multichannel/campania/:id" element={<RequireGroups groups={['mailing', 'mailing_admin', 'admin']}><CampaniaDetalle /></RequireGroups>} />
        <Route path="multichannel/reporte/:id" element={<RequireGroups groups={['mailing', 'mailing_admin', 'admin']}><ReporteDetalle /></RequireGroups>} />
        <Route path="multichannel/reporte-whatsapp/:id" element={<RequireGroups groups={['mailing', 'mailing_admin', 'admin']}><ReporteWhatsAppDetalle /></RequireGroups>} />
        <Route path="multichannel/calendario" element={<RequireGroups groups={['mailing', 'mailing_admin', 'admin']}><CalendarioPage /></RequireGroups>} />
        <Route path="multichannel/*" element={<RequireGroups groups={['mailing', 'mailing_admin', 'admin']}><CampaniasSeguimiento /></RequireGroups>} />

        {/* Contenido */}
        <Route path="contenido" element={<ContenidoPage />} />
        <Route path="contenido/*" element={<ContenidoPage />} />

        {/* WhatsApp - Solo admin */}
        <Route path="whatsapp/configuracion" element={<RequireGroups groups={['admin']}><ConfiguracionWhatsApp /></RequireGroups>} />
        <Route path="whatsapp/plantillas/twilio" element={<RequireGroups groups={['admin']}><PlantillasWhatsApp /></RequireGroups>} />
        <Route path="whatsapp/envio-masivo" element={<RequireGroups groups={['admin']}><EnvioMasivoWhatsApp /></RequireGroups>} />
        <Route path="whatsapp/historial" element={<RequireGroups groups={['admin']}><HistorialWhatsApp /></RequireGroups>} />
        <Route path="whatsapp/analytics/:envioId" element={<RequireGroups groups={['admin']}><AnalyticsWhatsApp /></RequireGroups>} />
        <Route path="whatsapp" element={<Navigate to="/whatsapp/historial" replace />} />
        <Route path="whatsapp/*" element={<Navigate to="/whatsapp/historial" replace />} />

        {/* Visualizaciones - grupo Visualizaciones (lectura) + admin (gestión) */}
        <Route path="visualizaciones" element={<RequireGroups groups={['Visualizaciones', 'admin']}><VisualizacionesPage /></RequireGroups>} />
        <Route path="visualizaciones/:id" element={<RequireGroups groups={['Visualizaciones', 'admin']}><VisualizacionDetailPage /></RequireGroups>} />
        <Route path="link-tracker" element={<RequireGroups groups={['admin', 'link_tracker']}><DashboardLinkTracker /></RequireGroups>} />
        <Route path="link-tracker/urls" element={<RequireGroups groups={['admin', 'link_tracker']}><ListaURLs /></RequireGroups>} />
        <Route path="link-tracker/crear" element={<RequireGroups groups={['admin', 'link_tracker']}><CrearURL /></RequireGroups>} />
        <Route path="link-tracker/analytics/:codigo" element={<RequireGroups groups={['admin', 'link_tracker']}><AnalyticsURLPage /></RequireGroups>} />

        {/* CEMC - Reportes por laboratorio */}
        <Route path="cemc/configuracion" element={<ConfiguracionClientesPage />} />
        <Route path="cemc/:slug" element={<ReportesClientePage />} />

        {/* Programmatic - Reportes Looker Studio por grupo */}
        <Route path="programmatic/configuracion" element={<ConfiguracionProgrammaticPage />} />
        <Route path="programmatic/:slug" element={<ReportesProgrammaticPage />} />

        {/* Analytics - Reportes por laboratorio */}
        <Route path="analytics/configuracion" element={<ConfiguracionAnalyticsPage />} />
        <Route path="analytics/:slug" element={<ReportesAnalyticsPage />} />

        {/* Webinars - Reportes por laboratorio */}
        <Route path="webinars/configuracion" element={<ConfiguracionWebinarsPage />} />
        <Route path="webinars/:slug" element={<ReportesWebinarsPage />} />

        {/* Webinars - Reporte analítico GrupoFarma (Google Sheets en vivo) */}
        <Route path="dash/grupofarma/webinars" element={<RequireGroups groups={['Grupofarma', 'admin']}><WebinarsGrupoFarmaPage /></RequireGroups>} />

        {/* Fidelización - viewers ven reportes; admins ven reportes + configuración */}
        <Route path="reportes-fidelizacion" element={<RequireGroups groups={GRUPOS_FIDELIZACION_VIEW}><ReportesFidelizacionPage /></RequireGroups>} />
        <Route path="reportes-fidelizacion/configuracion" element={<RequireGroups groups={['admin', 'fidelizacion_admin']}><ConfiguracionFidelizacionPage /></RequireGroups>} />
        <Route path="reportes-fidelizacion/:id" element={<RequireGroups groups={GRUPOS_FIDELIZACION_VIEW}><TabFidelizacionGuard tab="resumen"><ReporteFidelizacionDetallePage /></TabFidelizacionGuard></RequireGroups>} />
        <Route path="reportes-fidelizacion/:id/registros" element={<RequireGroups groups={GRUPOS_FIDELIZACION_VIEW}><RegistrosFidelizacionPage /></RequireGroups>} />
        <Route path="reportes-fidelizacion/:id/representantes" element={<RequireGroups groups={GRUPOS_FIDELIZACION_VIEW}><TabFidelizacionGuard tab="representantes"><RepresentantesFidelizacionPage /></TabFidelizacionGuard></RequireGroups>} />
        <Route path="reportes-fidelizacion/:id/ventas" element={<RequireGroups groups={GRUPOS_FIDELIZACION_VIEW}><VentasFidelizacionPage /></RequireGroups>} />
        <Route path="reportes-fidelizacion/:id/canjes" element={<RequireGroups groups={GRUPOS_FIDELIZACION_VIEW}><TabFidelizacionGuard tab="canjes"><CanjesFidelizacionPage /></TabFidelizacionGuard></RequireGroups>} />
        <Route path="reportes-fidelizacion/:id/participantes" element={<RequireGroups groups={GRUPOS_FIDELIZACION_VIEW}><TabFidelizacionGuard tab="participantes"><ParticipantesFidelizacionPage /></TabFidelizacionGuard></RequireGroups>} />
        <Route path="sueroterapia/reporte" element={<RequireGroups groups={['admin', 'Sueroterapia-admin', 'Sueroterapia']}><ReporteSueroterapiaPage /></RequireGroups>} />
        <Route path="sueroterapia/configuracion" element={<RequireGroups groups={['admin', 'Sueroterapia-admin']}><ConfiguracionSueroterapiaPage /></RequireGroups>} />
        <Route path="difare-expertos" element={<RequireGroups groups={['admin', 'Difare-admin', 'Difare', 'Difare-analytics']}><ReporteAnalyticsDifarePage /></RequireGroups>} />
        <Route path="difare-expertos/configuracion" element={<RequireGroups groups={['admin', 'Difare-admin']}><ConfiguracionAnalyticsDifarePage /></RequireGroups>} />
        <Route path="odf-expertos" element={<RequireGroups groups={['admin', 'data-odf-doctors']}><ReporteAnalyticsOdfPage /></RequireGroups>} />
        <Route path="odf-expertos/configuracion" element={<RequireGroups groups={['admin']}><ConfiguracionAnalyticsOdfPage /></RequireGroups>} />

        {/* Registros - Registros o admin */}
        <Route path="registros/reportes" element={<RequireGroups groups={['Registros', 'admin']}><ReportesPage /></RequireGroups>} />
        <Route path="registros/dashboard/:grupoId" element={<RequireGroups groups={['Registros', 'admin']}><DashboardPersonalizadoPage /></RequireGroups>} />
        <Route path="registros/reporte/:id" element={<RequireGroups groups={['Registros', 'admin']}><ReporteDetallePage /></RequireGroups>} />
        <Route path="registros/asistencias/:configId" element={<RequireGroups groups={['Registros', 'admin']}><AsistenciasDashboardPage /></RequireGroups>} />
        <Route path="registros/configuracion" element={<RequireGroups groups={['admin']}><ConfiguracionPage /></RequireGroups>} />
        <Route path="registros/adium" element={<RequireGroups groups={['admin', 'Adium (Vertismed)']}><AdiumRegistrosPage /></RequireGroups>} />
        <Route path="registros/adium/encuesta" element={<RequireGroups groups={['admin', 'Adium (Vertismed)']}><AdiumEncuestaPage /></RequireGroups>} />
        <Route path="registros" element={<RequireGroups groups={['Registros', 'admin']}><ReportesPage /></RequireGroups>} />
        <Route path="cemc-educacion" element={<RequireGroups groups={['CEMC-Educacion', 'CEMC-Educacion-admin']}><DashboardCEMCPage /></RequireGroups>} />
        <Route path="cemc-educacion/configuracion" element={<RequireGroups groups={['CEMC-Educacion-admin']}><ConfiguracionCEMCPage /></RequireGroups>} />
        <Route path="cemc-educacion/configuracion/:configId/fuentes" element={<RequireGroups groups={['CEMC-Educacion-admin']}><GestionFuentesPage /></RequireGroups>} />
        <Route path="cemc-educacion/reporte/:configId" element={<RequireGroups groups={['CEMC-Educacion', 'CEMC-Educacion-admin']}><ReporteCEMCPage /></RequireGroups>} />

        {/* Usuarios - Solo admin */}
        <Route path="usuarios" element={<RequireGroups groups={['admin']}><UsersPage /></RequireGroups>} />
        <Route path="usuarios/grupos" element={<RequireGroups groups={['admin']}><GroupsPage /></RequireGroups>} />
        <Route path="usuarios/laboratorios" element={<RequireGroups groups={['admin']}><LaboratoriosPage /></RequireGroups>} />
        <Route path="usuarios/areas" element={<RequireGroups groups={['admin']}><AreasPage /></RequireGroups>} />

        {/* BD Unificada - microservicio externo tonal-ms-bd */}
        <Route path="bd-unificada" element={<RequireGroups groups={['BdUnificada', 'BdUnificada-admin', 'admin']}><BdUnificadaContactosPage /></RequireGroups>} />
        <Route path="bd-unificada/fuentes" element={<RequireGroups groups={['BdUnificada-admin', 'admin']}><BdUnificadaFuentesPage /></RequireGroups>} />
        <Route path="bd-unificada/cola" element={<RequireGroups groups={['BdUnificada-admin', 'admin']}><BdUnificadaColaPage /></RequireGroups>} />
        <Route path="bd-unificada/configuracion" element={<RequireGroups groups={['BdUnificada-admin', 'admin']}><BdUnificadaConfiguracionPage /></RequireGroups>} />

        {/* Medifarma - Seguimiento (protected) */}
        <Route path="medifarma/seguimiento" element={<SeguimientoPage />} />

        {/* Passwords - contrasenas o admin */}
        <Route path="passwords" element={<RequireGroups groups={['contrasenas', 'admin']}><PasswordsPage /></RequireGroups>} />

        {/* BD Clientes */}
        <Route path="bd-clientes" element={<DashboardBdClientesPage />} />
        <Route path="bd-clientes/seguimiento" element={<ClientesListPage />} />
        <Route path="bd-clientes/configuracion" element={<ConfiguracionBdClientesPage />} />
        <Route path="bd-clientes/crear" element={<ClienteFormPage />} />
        <Route path="bd-clientes/carga-masiva" element={<BulkUploadPage />} />
        {/* Laboratorios (antes de :id para evitar conflicto) */}
        <Route path="bd-clientes/laboratorios" element={<LaboratoriosDashboardPage />} />
        <Route path="bd-clientes/laboratorios/seguimiento" element={<LaboratoriosListPage />} />
        <Route path="bd-clientes/laboratorios/configuracion" element={<LaboratoriosConfigPage />} />
        <Route path="bd-clientes/laboratorios/crear" element={<LaboratorioFormPage />} />
        <Route path="bd-clientes/laboratorios/:id" element={<LaboratorioDetailPage />} />
        <Route path="bd-clientes/laboratorios/:id/editar" element={<LaboratorioFormPage />} />
        {/* Clientes detail (después de laboratorios) */}
        <Route path="bd-clientes/:id" element={<ClienteDetailPage />} />
        <Route path="bd-clientes/:id/editar" element={<ClienteFormPage />} />

        {/* Sorteos */}
        <Route path="sorteos" element={<SorteosListPage />} />
        <Route path="sorteos/crear" element={<SorteoFormPage />} />
        <Route path="sorteos/:id" element={<SorteoDetailPage />} />
        <Route path="sorteos/:id/editar" element={<SorteoFormPage />} />

        {/* Código QR personal */}
        <Route path="codigos-qr" element={<CodigosQRPage />} />

        {/* Libro QR - Admin */}
        <Route path="libro-qr" element={<RequireGroups groups={['QR_codigo_unico', 'admin']}><QRLibrosListPage /></RequireGroups>} />
        <Route path="libro-qr/crear" element={<RequireGroups groups={['QR_codigo_unico', 'admin']}><QRLibroFormPage /></RequireGroups>} />
        <Route path="libro-qr/:id" element={<RequireGroups groups={['QR_codigo_unico', 'admin']}><QRLibroDetailPage /></RequireGroups>} />
        <Route path="libro-qr/:id/editar" element={<RequireGroups groups={['QR_codigo_unico', 'admin']}><QRLibroFormPage /></RequireGroups>} />

        {/* Muestras Médicas - Admin */}
        <Route path="muestras-medicas" element={<CampaniasListPage />} />
        <Route path="muestras-medicas/:id" element={<CampaniaDetallePage />} />
        <Route path="muestras-medicas/:id/solicitudes" element={<ReporteDatosPage />} />
        <Route path="muestras-medicas/:id/form-builder" element={<FormBuilderPage />} />
        <Route path="muestras-medicas/:id/encuestas" element={<EncuestasAdminPage />} />
        <Route path="muestras-medicas/:id/encuestas/form-builder" element={<EncuestaFormBuilderPage />} />
        <Route path="muestras-medicas/:id/encuestas/analiticas" element={<EncuestaAnaliticasPage />} />

        {/* Encuestas - Admin */}
        <Route path="encuestas" element={<EncuestasListPage />} />
        <Route path="encuestas/crear" element={<EncuestaCreatePage />} />
        <Route path="encuestas/:id/editar" element={<EncuestaEditPage />} />
        <Route path="encuestas/:id/preview" element={<EncuestaPreviewPage />} />
        <Route path="encuestas/reportes" element={<EncuestasReportesListPage />} />
        <Route path="encuestas/reportes/:id/datos" element={<EncuestasReporteDatosPage />} />
        <Route path="encuestas/reportes/:id/estadisticas" element={<EncuestasReporteEstadisticasPage />} />

        {/* Seguimiento Reportes - Solo admin */}
        <Route path="seguimiento-reportes" element={<RequireGroups groups={['admin']}><SeguimientoReportesPage /></RequireGroups>} />
        <Route path="seguimiento-reportes/:id" element={<RequireGroups groups={['admin']}><SeguimientoDetallePage /></RequireGroups>} />

        {/* Estadísticas Enterprise - Solo admin */}
        <Route path="estadisticas" element={<RequireGroups groups={['admin']}><EstadisticasPage /></RequireGroups>} />

        {/* Consumo IA */}
        <Route path="consumo-ia" element={<ConsumoIAPage />} />
        {/* Consumo Meta - Solo Tonal y admin */}
        <Route path="consumo-meta" element={<RequireGroups groups={['Tonal', 'admin']}><ConsumoMetaPage /></RequireGroups>} />
        <Route path="consumo-meta/lab/:labId" element={<RequireGroups groups={['Tonal', 'admin']}><ConsumoMetaLabPage /></RequireGroups>} />

        {/* Dash Reports Admin */}
        <Route path="dash-admin" element={<RequireGroups groups={['admin', 'Dash']}><DashAdminPage /></RequireGroups>} />

        {/* Pricing */}
        <Route path="pricing/admin" element={<PricingAdminPage />} />

        {/* Notificaciones */}
        <Route path="notificaciones" element={<NotificacionesPage />} />

        {/* Configuracion */}
        <Route path="configuracion" element={<ConfiguracionCampanias />} />

        {/* Catch-all for authenticated users - redirect to home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>

      {/* Catch-all for unauthenticated users - handled by ProtectedRoute */}
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  )
}

export default App
